import React from 'react';
import { Link } from 'react-router';

import styles from './styles/NewsItem.module.scss';

// Types.
import { formatFullDateTime } from '../../utils/billing';

type NewsItemProps = {
  key?: string | number;
  to: string;
  title: string;
  time?: number;
};

const NewsItem: React.FunctionComponent<NewsItemProps> = (props: NewsItemProps) => {
  const { to, title, time } = props;

  return (
    <Link to={to} className={styles.newsItem}>
      <h4 className="h6">
        {title}
        {time && <time dateTime={new Date(time).toISOString()}>{formatFullDateTime(time)}</time>}
      </h4>
    </Link>
  );
};

export default NewsItem;
